import {
	AfterViewInit,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output
} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';
import { Invoice } from '@models/invoice.model';

import { Location } from '@angular/common';
import { InvoicesDataProvider } from '@services/invoice/invoices-data-service/invoices.data.service';
import { PaymentsServiceProvider } from '@services/payments/payments-service/payments.service';
import { IntegrationsDataProvider } from '@services/integrations/integrations.data.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { Integrations } from '@models/models';
import { SNModalService } from '@web-services/modal/snModal.service';
import { ConfirmGeneralModalComponent } from '@web-components/common/confirm-general-modal/confirm-general-modal.component';

@Component({
	selector: 'invoice-payment-action-buttons',
	template: require('./invoice-payment-action-buttons.html'),
	styles: [require('./invoice-payment-action-buttons.scss')]
})
export class InvoicePaymentActionButtons implements OnInit, AfterViewInit {
	@Input('data') data: Invoice;
	@Output() getInvoiceUpdated: EventEmitter<Invoice> = new EventEmitter();
	@Output() sendInvoiceEmitter: EventEmitter<any> = new EventEmitter();

	previewUrl: string;
	editUrl: string;
	isFullyPaid: boolean;
	xeroEnabled: boolean;
	qbEnabled: boolean;
	isDeleteModalOpen: boolean;

	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private invoicesDataService: InvoicesDataProvider,
		private paymentsService: PaymentsServiceProvider,
		private integrationsDataService: IntegrationsDataProvider,
		private messageService: MessageService,
		private location: Location,
		private modalService: SNModalService
	) {}

	ngOnInit(): void {
		this.loadPreviewUrl();
		this.getIntegrationStatus();
	}

	ngAfterViewInit(): void {
		this.prepareEditLink();
	}

	updateInvoice(invoice: Invoice): void {
		this.getInvoiceUpdated.emit(invoice);
	}

	sendInvoice(invoice: Invoice): void {
		const { message } = this.data.actions.SEND;

		if (message) {
			this.openAlertModal(message);
			return;
		}

		this.sendInvoiceEmitter.emit({ isReceipt: false, data: invoice });
	}

	showDeleteModal(): void {
		const { message } = this.data.actions.DELETE;
		if (message) {
			this.openAlertModal(message);
			return;
		}

		this.isDeleteModalOpen = true;
		$('#deleteModal').modal();
	}

	successDeleteInvoiceModal(state): void {
		if (state) {
			this.isDeleteModalOpen = false;
			this.location.go('/payments');
		}
	}

	private loadPreviewUrl(): void {
		this.invoicesDataService
			.getInvoicePreviewURL(this.data.id)
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(data => {
				this.previewUrl = `/clients/invoice/pay/${data.link}/${this.data.id}`;
			});
	}

	private prepareEditLink(): void {
		this.data.job.inLead
			? (this.editUrl = `/leads/${this.data.job.leadId}/invoice/${
					this.data.id
			  }/update`)
			: (this.editUrl = `/jobs/${this.data.job.id}/invoice/${
					this.data.id
			  }/update`);
	}

	private getIntegrationStatus(): void {
		this.integrationsDataService
			.getIntegrationOrganization()
			.subscribe(
				data => this.successGetIntegrationStatus(data),
				err => this.messageService.showDefaultErrorMessage(err)
			);
	}

	private successGetIntegrationStatus(data: Integrations): void {
		if (data.integration && data.integration === 'XERO') {
			this.xeroEnabled = true;
			this.qbEnabled = false;
		} else if (data.integration && data.integration === 'QUICKBOOKS') {
			this.qbEnabled = true;
			this.xeroEnabled = false;
		}
	}

	private openAlertModal(message: string): void {
		const modal = this.modalService.openModal(ConfirmGeneralModalComponent, {
			windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
		});
		modal.componentInstance.text = message;

		modal.componentInstance.buttons = [
			{
				text: 'Okay',
				action: 'CLOSE',
				color: 'default',
				size: 'lg'
			}
		];
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/invoices/invoice-view/invoice-payments-action-buttons/invoice-payment-action-buttons.ts